import React, { useState, useEffect } from "react";

// material
import {
  Box,
  Card,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Modal,
  Switch,
  Typography
} from "@mui/material";
import { Stack, Container, TextField, Button, Tooltip, IconButton } from "@mui/material";
import Page from "../components/Page";
import { notification } from "src/utils/messages";
import { EditSharp, ImageSearchRounded } from "@mui/icons-material";
import "../Assets/css/style.css";
import DataTable from "react-data-table-component";
import { Routes } from "../constant/api_url";
import {
  insertLvbRecordsDynamic,
  updateLvbRecordsDynamic,
  getLvbRecordsDynamic
} from "src/api/commonapi";
import Label from "src/components/Label";
import { CSVLink } from "react-csv";
import CustomLoader from "src/commonComponents/CustomLoader";

export default function LvbRecordsDynamic() {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    height: "80vh", // ✅ ADD THIS
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px 0px 0px 10px",
    p: 2,
    overflowY: "auto" // ✅ IMPORTANT for scroll
  };

  const [addEditModal, setAddEditModal] = useState(false);
  const [mode, setMode] = useState("Add");
  const [isLoading, setIsLoading] = useState(false);

  const [recordData, setRecordData] = useState({
    record_img: "",
    title: "",
    value: "",
    description: "",
    position: 0,
    record_in_setting: 0,
    show_before_record: 0
  });
  const [tableData, setTableData] = useState([]);
  const toggleAddEditModal = () => setAddEditModal(!addEditModal);

  const resetFormData = () => {
    setRecordData({
      record_img: "",
      title: "",
      value: "",
      description: "",
      position: 0,
      record_in_setting: 0,
      show_before_record: 0
    });
  };
  const handleRecordSubmit = async (newData = undefined) => {
    if (newData != undefined ? newData : recordData.l_r_id != undefined) {
      // update Existing Record
      if (
        (newData != undefined ? newData : recordData).record_img != "" &&
        (newData != undefined ? newData : recordData).title != "" &&
        (newData != undefined ? newData : recordData).position != "" &&
        (newData != undefined ? newData : recordData).value != ""
      ) {
        let fnData = new FormData();
        fnData.append("l_r_id", newData != undefined ? newData.l_r_id : recordData.l_r_id);
        fnData.append(
          "record_img",
          newData != undefined ? newData.record_img : recordData.record_img
        );
        fnData.append("title", newData != undefined ? newData.title : recordData.title);
        fnData.append("value", newData != undefined ? newData.value : recordData.value);
        fnData.append(
          "description",
          newData != undefined ? newData.description : recordData.description
        );
        fnData.append("position", newData != undefined ? newData.position : recordData.position);
        fnData.append(
          "record_in_setting",
          newData != undefined ? newData.record_in_setting : recordData.record_in_setting
        );
        fnData.append(
          "show_before_record",
          newData != undefined ? newData.show_before_record : recordData.show_before_record
        );

        setIsLoading(true);
        let resp = await updateLvbRecordsDynamic(fnData);
        setIsLoading(false);
        if (resp.status != 0) {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
          resetFormData();
          newData == undefined && toggleAddEditModal();
          getLvbRecords();
        } else {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
        }
      } else {
        let notify = notification({
          type: "error",
          message: "Please Fill Required Fields data"
        });
        notify();
      }
    } else {
      // Insert New Record
      if (
        recordData.record_img != "" &&
        recordData.title != "" &&
        recordData.position != "" &&
        recordData.value != ""
      ) {
        let fnData = new FormData();
        fnData.append("record_img", recordData.record_img);
        fnData.append("title", recordData.title);
        fnData.append("value", recordData.value);
        fnData.append("description", recordData.description);
        fnData.append("position", recordData.position);
        fnData.append("record_in_setting", recordData.record_in_setting);
        fnData.append("show_before_record", recordData.show_before_record);

        setIsLoading(true);
        let resp = await insertLvbRecordsDynamic(fnData);
        setIsLoading(false);
        if (resp.status != 0) {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
          resetFormData();
          toggleAddEditModal();
          getLvbRecords();
        } else {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
        }
      } else {
        let notify = notification({
          type: "error",
          message: "Please Fill Required Fields data"
        });
        notify();
      }
    }
  };

  const getLvbRecords = async () => {
    setIsLoading(true);
    let res = await getLvbRecordsDynamic();
    setIsLoading(false);
    setTableData(res?.data);
  };
  useEffect(() => {
    getLvbRecords();
  }, []);

  const expo_columns = [
    { label: "No", key: "l_r_id" },
    { label: "Name", key: "title" },
    { label: "Value", key: "value" },
    { label: "Image", key: "record_img" },
    { label: "Description", key: "description" },
    { label: "Position", key: "position" },
    { label: "Add Record In Setting", key: "record_in_setting" },
    { label: "Show Before Record", key: "show_before_record" }
  ];

  const settingLabel = ["Off", "On"];

  const columns = [
    {
      name: "No",
      wrap: true,
      selector: (row) => row?.l_r_id,
      sortable: true,
      width: "70px"
    },
    {
      name: "Name",
      wrap: true,
      selector: (row) => row?.title,
      sortable: true
    },
    {
      name: "Value",
      wrap: true,
      selector: (row) => row?.value,
      sortable: true
    },

    {
      name: "Add Record In Setting",
      wrap: true,
      selector: (row) => <span>{settingLabel[row?.record_in_setting]}</span>,
      sortable: true
    },
    {
      name: "Show Before Record",
      wrap: true,
      selector: (row) => <span>{settingLabel[row?.show_before_record]}</span>,
      sortable: true
    },
    {
      name: "Image",
      selector: (row) => (
        <>
          <img
            title={row.title}
            src={`${Routes.API_HOSTNAME}lvb-records/${row?.record_img}`}
            width="50"
            alt={row.title}
          />
        </>
      ),
      sortable: true
    },
    {
      name: "Position",
      wrap: true,
      selector: (row) => row?.position || "-",
      sortable: true
    },

    {
      name: "Action",
      wrap: true,
      sortable: true,
      width: "100px",
      selector: (row) => (
        <>
          <Tooltip title="Edit Record">
            <IconButton
              onClick={() => {
                setRecordData({
                  l_r_id: row.l_r_id,
                  record_img: row.record_img,
                  title: row.title,
                  value: row.value,
                  description: row.description,
                  position: row.position,
                  record_in_setting: row.record_in_setting,
                  show_before_record: row.show_before_record
                });
                toggleAddEditModal();
                setMode("Edit");
              }}
            >
              <EditSharp color="warning" />
            </IconButton>
          </Tooltip>
        </>
      )
    }
  ];

  const ExpandedComponent = ({ data }) => (
    <div style={{ padding: "15px" }}>
      <strong>Description:</strong>
      <p style={{ marginTop: "8px" }}>{data.description || "No description available"}</p>
    </div>
  );

  const exportData = tableData?.map((row) => ({
    ...row,
    record_in_setting: settingLabel[row?.record_in_setting],
    show_before_record: settingLabel[row?.show_before_record]
  }));

  return (
    <>
      <Page title="LVB Records Dynamic | Local Vocal Business Group">
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                <Typography variant="h4" gutterBottom>
                  LVB Records Dynamic
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={6}>
              <Button
                onClick={() => {
                  toggleAddEditModal();
                  setMode("Add");
                }}
                style={{ marginBottom: "15px", float: "right" }}
                variant="contained"
              >
                Add Record
              </Button>
            </Grid>
          </Grid>

          <Modal
            open={addEditModal}
            onClose={() => (toggleAddEditModal(), resetFormData())}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                style={{ marginBottom: "5px", textAlign: "center" }}
              >
                {mode} Record
              </Typography>
              <hr />
              <Stack spacing={10} style={{ marginBottom: "5px" }}>
                <Grid container>
                  <Grid item xs={12} sm={12} p={1}>
                    <h4
                      style={{
                        textAlign: "center",
                        marginBottom: "5px"
                      }}
                    >
                      Select Image For Icon *
                    </h4>
                    <label className="pinImageLabel" htmlFor="image">
                      <div className="selectImage" style={{ textAlign: "center" }}>
                        {recordData?.record_img?.length != 0 ? (
                          <img
                            src={
                              recordData?.record_img instanceof File
                                ? URL.createObjectURL(recordData.record_img)
                                : `${Routes.API_HOSTNAME}lvb-records/${recordData?.record_img}`
                            }
                            alt="img"
                            className="selectedImage"
                            width="140px"
                            height="140px"
                            style={{ margin: "5px" }}
                          />
                        ) : (
                          <>
                            <ImageSearchRounded color="primary" />
                            <h5> Select Image </h5>
                          </>
                        )}
                      </div>

                      <input
                        id="image"
                        name="record_img"
                        type="file"
                        hidden
                        accept="image/*"
                        className="form-control"
                        onChange={(e) => {
                          setRecordData({
                            ...recordData,
                            record_img: e.currentTarget.files[0]
                          });
                        }}
                      />
                    </label>
                    <Label
                      variant={"ghost"}
                      color={"error"}
                      style={{
                        margin: "10px auto",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "fit-content",
                        // paddingBottom: "5px",
                        // paddingTop: "5px",
                        fontSize: "14px"
                      }}
                    >
                      Note : Image Size Must Be 512 * 512
                    </Label>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      style={{ marginTop: "15px" }}
                      height={10}
                      fullWidth
                      multiline
                      autoComplete="off"
                      type="text"
                      label="Name *"
                      name="title"
                      placeholder="Enter Name"
                      onChange={(e) => {
                        setRecordData({
                          ...recordData,
                          title: e.target.value
                        });
                      }}
                      value={recordData?.title}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      style={{ marginTop: "15px" }}
                      height={10}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Value *"
                      name="value"
                      placeholder="Enter Value"
                      onChange={(e) => {
                        setRecordData({
                          ...recordData,
                          value: e.target.value
                        });
                      }}
                      value={recordData?.value}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      style={{ marginTop: "15px" }}
                      height={10}
                      fullWidth
                      multiline
                      minRows={3} // ✅ like rows in textarea
                      maxRows={5}
                      autoComplete="off"
                      type="text"
                      label="Description"
                      name="description"
                      placeholder="Enter Description"
                      onChange={(e) => {
                        setRecordData({
                          ...recordData,
                          description: e.target.value
                        });
                      }}
                      value={recordData?.description}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12}>
                    <TextField
                      style={{ marginTop: "15px" }}
                      fullWidth
                      autoComplete="off"
                      type="number"
                      label="Position *"
                      name="position"
                      placeholder="Enter Value"
                      inputProps={{
                        min: 1
                      }}
                      onChange={(e) => {
                        const val = e.target.value;

                        if (val === "") {
                          setRecordData({
                            ...recordData,
                            position: ""
                          });
                          return;
                        }

                        if (Number(val) > 0) {
                          setRecordData({
                            ...recordData,
                            position: val
                          });
                        }
                      }}
                      value={recordData?.position}
                    />
                  </Grid>
                  <Grid item sm={6} xs={12} sx={{ marginTop: 1 }}>
                    <FormControl component="fieldset">
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={recordData.record_in_setting}
                              onChange={(e) => {
                                setRecordData({
                                  ...recordData,
                                  record_in_setting: e.target.checked ? 1 : 0
                                });
                              }}
                            />
                          }
                          label="Show In App"
                        />
                      </FormGroup>
                    </FormControl>
                  </Grid>
                  <Grid item sm={6} xs={12} sx={{ marginTop: 1 }}>
                    <FormControl component="fieldset">
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={recordData.show_before_record}
                              onChange={(e) => {
                                setRecordData({
                                  ...recordData,
                                  show_before_record: e.target.checked ? 1 : 0
                                });
                              }}
                            />
                          }
                          label="Show Before Record"
                        />
                      </FormGroup>
                    </FormControl>
                  </Grid>

                  <Grid
                    item
                    sm={12}
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center"
                    }}
                  >
                    <Button
                      variant="outlined"
                      onClick={() => (toggleAddEditModal(), resetFormData())}
                      style={{ marginTop: "15px" }}
                    >
                      Close
                    </Button>
                    <Button
                      variant="contained"
                      style={{ marginTop: "15px" }}
                      onClick={() => handleRecordSubmit()}
                      disabled={isLoading}
                      startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </Stack>
            </Box>
          </Modal>

          {/*  */}

          <Card spacing={3} style={{ padding: "10px", marginTop: "20px" }}>
            <Button className="btn btn-export">
              <CSVLink
                data={exportData}
                headers={expo_columns}
                filename={"LVB Records Dynamic.csv"}
                className="btn btn-primary test"
                target="_blank"
              >
                Export CSV
              </CSVLink>
            </Button>
            <DataTable
              filter
              pagination
              highlightOnHover
              columns={columns}
              data={tableData != null ? tableData : []}
              expandableRows // ✅ enable expand
              expandableRowsComponent={ExpandedComponent}
              expandableRowDisabled={(row) => !row.description} // 👈 disable if no description
              progressPending={isLoading}
              progressComponent={<CustomLoader />}
            />
          </Card>
        </Container>
      </Page>
    </>
  );
}
